<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-dialog
    v-model="realValue"
    max-width="1200px"
    persistent
  >
    <v-card>
      <div class="d-flex align-center pa-4">
        <div class="text-h3 font-weight-bold">
          {{ $t('newProduct') }}
        </div>
        <v-spacer/>
        <div>
          <v-btn
            icon
            @click="$emit('close')"
          >
            <v-icon large>
              mdi-close
            </v-icon>
          </v-btn>
        </div>
      </div>
      <template>
        <template v-if="!loading">
          <v-stepper
            v-model="step"
            elevation="0"
          >
            <v-stepper-header>
              <v-stepper-step
                :complete="step > 1"
                :editable="step > 1"
                :step="1"
              >
                {{ $t('normalInfo') }}
              </v-stepper-step>

              <v-divider/>

              <v-stepper-step
                :complete="step > 2"
                :editable="step2Rule"
                :step="2"
              >
                {{ $t('dishClassify') }}
              </v-stepper-step>

              <v-divider/>

              <v-stepper-step
                :complete="step > 3"
                :editable="step3Rule"
                :step="3"
              >
                {{ $t('orderPrinter') }}
              </v-stepper-step>

              <v-divider/>

              <v-stepper-step
                :complete="step > 4"
                :editable="step45Rule"
                :step="4"
              >
                {{ $t('otherInfo') }}
              </v-stepper-step>

              <v-divider/>


              <v-stepper-step
                :complete="step > 5"
                :step="5"
              >
                {{ $t('confirmInfo') }}
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content :step="1">
                <div v-if="step===1&&editedItem">
                  <v-form
                    ref="stepOneForm"
                    v-model="valid"
                    lazy-validation
                  >
                    <template v-for="(field,index) in groupedFields">
                      <div
                        v-if="editedItem[field.value]"
                        :key="field.value+index+'group'"
                      >
                        <div class="d-flex align-center">
                          <div>
                            <div class="text-h4 font-weight-medium">
                              {{ $t('' + field.groupName) }}
                            </div>
                            <div class="text-caption">
                              {{ $t('other_lang_could_not_be_filled_if_not_fill_just_one_lang_can_be_used') }}
                            </div>
                          </div>
                          <v-spacer/>
                          <div class="d-flex">
                            <div>
                              <v-tabs
                                v-model="langTab"
                                color="#232123"
                                height="36px"
                                style="background: transparent!important;"
                              >
                                <v-tab
                                  v-for="(child,i) in field.children"
                                  :key="field.value+'c'+editedItem[field.value][i][field.childLabelKey]+'tab'"
                                >
                                  {{ $t(editedItem[field.value][i][field.childLabelKey].toLowerCase()) }}
                                  <span
                                    v-if="i===0"
                                    class="red--text"
                                  > * </span>
                                </v-tab>
                              </v-tabs>
                            </div>
                          </div>
                        </div>
                        <v-tabs-items
                          v-model="langTab"
                          class="mt-4"
                        >
                          <v-tab-item
                            v-for="(child,i) in field.children"
                            :key="i+'dishId'"
                          >
                            <template v-for="(c,t) in child">
                              <div :key="field.id+'t'+t+'c'+i">
                                <form-field
                                  v-if="editedItem[field.value]"
                                  :current-state="editedIndex"
                                  :edited-item="editedItem[field.value][i]"
                                  :field="c"
                                  no-details
                                />
                              </div>
                            </template>
                          </v-tab-item>
                        </v-tabs-items>
                      </div>
                    </template>
                    <template v-for="(field,index) in normalInformation">
                      <div
                        :key="'f1'+index+field.text"
                      >
                        <form-field
                          :current-state="editedIndex"
                          :edited-item="editedItem"
                          :field="field"
                          no-details
                          @click="addNew(-1)"
                        />
                      </div>
                    </template>
                  </v-form>
                </div>
              </v-stepper-content>

              <v-stepper-content :step="2">
                <div class="text-h4 font-weight-bold">
                  {{ $t('dishBelongClassify') }}
                </div>
                <div class="mt-2">
                  <v-item-group v-model="categorySelected">
                    <template v-if="!showCategoryDialog">
                      <div
                        style="display: grid;grid-template-columns: repeat(auto-fill,minmax(120px,1fr));grid-gap: 8px"
                      >
                        <v-card
                          class="d-flex align-center justify-center"
                          color="#eee"
                          outlined
                          @click="addNew(-1)"
                        >
                          <div class="text-center">
                            <v-icon size="48">
                              mdi-plus
                            </v-icon>
                          </div>
                        </v-card>
                        <v-item
                          v-for="x in categoryList"
                          :key="x.id"
                          v-slot="{ active, toggle }"
                        >
                          <v-card
                            :color="x.color"
                            class="d-flex align-center justify-center"
                            elevation="0"
                            outlined
                            @click="toggle();step=3"
                          >
                            <v-responsive
                              :aspect-ratio="1"
                            >
                              <div
                                class="d-flex align-center justify-center flex-column pa-2"
                                style="height: 100%;position: relative"
                              >
                                <v-icon
                                  v-if="active"
                                  color="primary"
                                  size="36"
                                  style="position: absolute;bottom: 0px;"
                                >
                                  mdi-check-circle
                                </v-icon>
                                <div class="text-center text-body-1">
                                  {{ x._langsname }}
                                </div>
                              </div>
                            </v-responsive>
                          </v-card>
                        </v-item>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="d-flex align-center justify-center"
                        style="height: 400px"
                      >
                        <v-progress-circular
                          indeterminate
                          size="64"
                        />
                      </div>
                    </template>
                  </v-item-group>
                </div>
              </v-stepper-content>

              <v-stepper-content :step="3">
                <div class="text-h4 font-weight-bold mb-2">
                  {{ $t('thisDishUsePrinter') }}
                </div>
                <v-item-group v-model="printerSelected">
                  <div style="display: grid;grid-template-columns: repeat(4,minmax(0,1fr));grid-gap: 12px">
                    <v-item
                      v-for="x in printerList"
                      :key="x.id"
                      v-slot="{ active, toggle }"
                    >
                      <v-card
                        class="pa-4"
                        outlined
                        style="position: relative"
                        @click="toggle();step=4"
                      >
                        <v-icon
                          v-if="active"
                          color="primary"
                          size="36"
                          style="position: absolute;bottom: 8px;right: 8px;z-index: 1"
                        >
                          mdi-check
                        </v-icon>
                        <div>
                          <div class="text-body-1">
                            {{ x.name }}
                          </div>

                          <v-card
                            class="d-flex justify-center mt-4"
                            elevation="0"
                          >
                            <v-img
                              v-if="x.name !== '不打印'"
                              :src="imgSrcEpson"
                              contain
                              height="196"
                              style="flex-grow: 0"
                              width="60%"
                            />
                            <div
                              v-else
                              class="d-flex align-center justify-center"
                              style="height: 196px;"
                            >
                              <v-icon
                                size="96"
                              >
                                mdi-block-helper
                              </v-icon>
                            </div>
                          </v-card>
                        </div>
                      </v-card>
                    </v-item>
                  </div>
                </v-item-group>
              </v-stepper-content>

              <v-stepper-content :step="4">
                <div class="text-h4 font-weight-bold">
                  {{ $t('optionInfo') }}
                </div>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <div
                    v-if="imageField.length>0"
                    class="mt-8"
                  >
                    <form-field
                      :current-state="editedIndex"
                      :edited-item="editedItem"
                      :field="imageField[0]"
                      no-details
                    />
                  </div>
                  <div>
                    <template v-for="(field,index) in notRequiredFields">
                      <div
                        v-if="isRefreshAllergen"
                        :key="'f2'+index"
                        class="my-4"
                      >
                        <form-field
                          :current-state="editedIndex"
                          :edited-item="editedItem"
                          :field="field"
                          no-details
                          @click="addNewAllergen(-1)"
                        />
                      </div>
                    </template>
                    <div class="my-4">
                      <div class="text-caption pb-1">
                        {{ $t('dishesShowThisMenu') }}
                      </div>
                      <v-select
                        v-model="selectedShowThisMenu"
                        :items="consumeTypeList"
                        :menu-props="{offsetY:true, outlined:true,
                                      contentClass:'elevation-2 ikRounded',nudgeBottom:'16px'}"
                        :placeholder="$t('chooseMenu')"
                        item-text="name"
                        item-value="id"
                        multiple
                        outlined
                        return-object
                      />
                    </div>
                    <div class="my-4">
                      <div class="text-caption pb-1">
                        {{ $t('dishesFreeThisMenu') }}
                      </div>
                      <v-select
                        v-model="selectedFreeMenu"
                        :items="consumeTypeList"
                        :menu-props="{offsetY:true, outlined:true, contentClass:'elevation-2 ikRounded',nudgeBottom:'16px'}"
                        :placeholder="$t('dishesFreeThisMenu')"
                        item-text="name"
                        item-value="id"
                        multiple
                        outlined
                        return-object
                      />
                    </div>
                  </div>
                </v-form>
              </v-stepper-content>

              <v-stepper-content :step="5">
                <div
                  v-if="editedItem"
                  class="pa-8"
                >
                  <div class="text-h3 font-weight-bold mb-8">
                    {{ $t('confirmSubmitInfo') }}
                  </div>
                  <div class="d-flex text-h4 align-center">
                    <div class="mr-4">
                      {{ $t('dishName') }}
                    </div>
                    <v-spacer/>
                    <div
                      class="font-weight-bold"
                    >
                      {{ editedItem.langs[0].name }}
                    </div>
                    <v-btn icon>
                      <v-icon @click="step = 1">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="d-flex text-h4 align-center">
                    <div class="mr-4">
                      {{ $t('dishNumber') }}
                    </div>
                    <v-spacer/>
                    <div class="font-weight-bold">
                      {{ editedItem.code }}
                    </div>
                    <v-btn icon>
                      <v-icon @click="step = 1">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="d-flex text-h4 align-center">
                    <div class="mr-4">
                      {{ $t('dishPrice') }}
                    </div>
                    <v-spacer/>
                    <div class="font-weight-bold">
                      {{ editedItem.price }}
                    </div>
                    <v-btn icon>
                      <v-icon @click="step = 1">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="d-flex text-h4 align-center">
                    <div class="mr-4">
                      {{ $t('dishShowMenu') }}
                    </div>
                    <v-spacer/>
                    <div class="font-weight-bold">
                      {{ selectShowMenuName }}
                    </div>
                    <v-btn icon>
                      <v-icon @click="step = 5">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="d-flex text-h4 align-center">
                    <div class="mr-4">
                      {{ $t('dishFreeMenu') }}
                    </div>
                    <v-spacer/>
                    <div class="font-weight-bold">
                      {{ selectFreeMenuName }}
                    </div>
                    <v-btn icon>
                      <v-icon @click="step = 5">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="d-flex text-h4 align-center">
                    <div class="mr-4">
                      {{ $t('dishClassify') }}:
                    </div>
                    <v-spacer/>
                    <div class="font-weight-bold">
                      {{ newAddCategorySelectedName }}
                    </div>
                    <v-btn icon>
                      <v-icon @click="step = 2">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                  <div class="d-flex text-h4 align-center mb-8">
                    <div class="mr-4">
                      {{ $t('orderPrinter') }}:
                    </div>
                    <v-spacer/>
                    <div class="font-weight-bold">
                      {{ newAddPrinterName }}
                    </div>
                    <v-btn icon>
                      <v-icon @click="step = 3">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </template>
        <template v-else>
          <div
            class="d-flex align-center justify-center"
            style="height: 400px"
          >
            <v-progress-circular
              indeterminate
              size="64"
            />
          </div>
        </template>
      </template>
      <div class="pa-4 ml-2">
        <div v-if="nextStepRule">
          <v-btn
            :disabled="!valid"
            class="primary"
            depressed
            @click="nextStep"
          >
            {{ $t('nextStep') }}
          </v-btn>
        </div>
        <div v-if="step === 5">
          <v-btn
            class="primary mr-4"
            depressed
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
          <v-btn
            depressed
            outlined
            @click="saveAndNewAdd"
          >
            {{ $t('saveAndAdd') }}
          </v-btn>
        </div>
      </div>
      <ik-entity-form
        v-model="showCategoryDialog"
        :edited-index="activeCategoryIndex"
        :model="categoryModel"
        :title="$t('category')"
        @need-refresh="loadCategory"
      />
      <ik-entity-form
        v-model="showAllergenDialog"
        :edited-index="activeAllergenIndex"
        :model="AllergenModel"
        :title="$t('allergicSource')"
        @need-refresh="loadAllergen"
      />
    </v-card>
  </v-dialog>
</template>

<script>
  import Dish from '@/model/dish/Dish'
  import { IKDataEntity, IkEntityForm } from 'metaflow-js'
  import FormField from 'metaflow-js/EntityFrameWork/VueTemplate/FormField'
  import IKUtils from 'innerken-js-utils'
  import Category from '@/model/dish/Category'
  import Allergen from '@/model/dish/Allergen'
  import ConsumeType from '@/model/buffet/ConsumeType'
  import DishesConsumeType from '@/model/buffet/DishesConsumeType'
  import { copyToAll, showSuccessMessage } from '@/common/utils'
  import PrinterGroup from '@/model/print/PrinterGroup'

  export default {
    name: 'DishesDetail',
    components: {
      IkEntityForm,
      FormField,
    },
    props: {
      newProductCode: {},
      value: {
        default: null,
        type: Boolean,
      },
    },
    data () {
      return {
        realValue: null,
        selectFreeMenuName: null,
        selectShowMenuName: null,
        newAddPrinterName: null,
        newAddCategorySelectedName: null,

        newDishCode: '',
        newAddCategorySelected: [],

        // imgSrcUsb: null,
        imgSrcEpson: null,
        step: 1,
        printerList: [],
        printerSelected: null,
        categorySelected: null,
        selectedFreeMenu: [],
        selectedShowThisMenu: [],
        consumeTypeList: [],
        categoryList: [],

        AllergenModel: Allergen,
        activeAllergenIndex: null,
        showAllergenDialog: null,
        showCategoryDialog: null,
        activeCategoryIndex: null,
        categoryModel: Category,
        isRefreshAllergen: true,

        loading: false,
        langTab: null,
        model: Dish,
        editedIndex: -1,
        tab: 0,
        valid: true,
        formField: [],
        currentList: [],
        IKDataEntity: IKDataEntity,
        defaultItem: null,
        calculateDefaultItem: null,
        editedItem: null,
        keyStore: {},

      }
    },
    computed: {
      nextStepRule () {
        return this.step === 1 || this.step === 4
      },
      step2Rule () {
        return this.valid
      },
      step3Rule () {
        return this.categorySelected !== null && this.step2Rule
      },
      step45Rule () {
        return this.printerSelected !== null && this.step3Rule
      },
      normalInformation () {
        return this.requiredFields.filter(f => f.value === 'code' || f.value === 'price')
      },
      requiredFields () {
        return this.notGroupedFields.filter(f => this.fieldIsRequired(f))
      },
      printIdInformation () {
        return this.notGroupedFields.filter(f => f.value === 'printGroupId')
      },
      notRequiredFields: function () {
        return this.notGroupedFields.filter(f => !this.fieldIsRequired(f))
      },
      groupedFields: function () {
        return this.notImageField.filter(f => f.dataType === IKDataEntity.Types.Group)
      },
      notGroupedFields: function () {
        return this.notImageField.filter(f => f.dataType !== IKDataEntity.Types.Group)
      },
      imageField: function () {
        return this.formField.filter(f => f.dataType === IKDataEntity.Types.Image)
      },
      uniqueField: function () {
        return this.formField.filter(f => f.unique)
      },
      notImageField: function () {
        return this.formField.filter(f => f.dataType !==
          IKDataEntity.Types.Image)
      },
      name () {
        return (this?.editedItem?.name ?? this.editedItem?.dishName ?? this.$t('load'))
      },
    },
    watch: {
      value: {
        immediate: true,
        handler (val) {
          this.realValue = val
        },
      },
      async realValue (val, old) {
        if (val !== old) {
          this.$emit('input', val)
        }
        if (!val) {
          await this.wait(async () => {
            await this.reload()
          })
        } else {
          this.selectedShowThisMenu = this.consumeTypeList
          this.selectedFreeMenu = []
          this.editedItem.code = this.newProductCode
        }
      },
    },
    async activated () {
      this.loading = true
      this.imgSrcEpson = require('@/assets/printers/epson-tm30.png')
      // this.imgSrcUsb = require('@/assets/printers/usb-sticker.png')
      await this.wait(async () => {
        [, this.formField, this.calculateDefaultItem] = IKDataEntity.parseField(this.model)
        Object.freeze(this.calculateDefaultItem)

        this.categoryList = (await Category.getList(true))
        this.printerList = (await PrinterGroup.getList(true))
        this.consumeTypeList = (await ConsumeType.getList(true))
        await this.reload()
      })
    },
    methods: {
      nextStep () {
        if (this.step === 1) {
          if (this.$refs.stepOneForm.validate()) {
            this.step = 2
          }
        } else {
          this.step = 5
          this.confirmToSubmit()
        }
      },
      async saveAndNewAdd () {
        this.editedIndex = -1
        if (this.editedIndex > -1) {
          await IKUtils.safeCallFunction(this.model, this.model.edit, this.editedItem)
          for (const d of this.consumeTypeList) {
            (await DishesConsumeType.edit({
              consumeTypeId: (d.id).toString(),
              dishId: this.$route.params.id,
              showing: false,
              isFree: false,
            }))
          }
          for (const x of this.selectedShowThisMenu) {
            (await DishesConsumeType.edit({
              consumeTypeId: (x.id).toString(),
              dishId: this.$route.params.id,
              showing: true,
            }))
          }
          for (const x of this.selectedFreeMenu) {
            (await DishesConsumeType.edit({
              consumeTypeId: (x.id).toString(),
              dishId: this.$route.params.id,
              isFree: true,
            }))
          }
          showSuccessMessage(this.$t('edit_success'))
          this.close(true)
        } else {
          for (const f of this.groupedFields) {
            copyToAll(f, this.editedItem[f.value])
          }
          if (!this.$refs.form.validate()) {
            return
          }
          await this.wait(async () => {
            const res = await Dish.add({
              ...this.editedItem,
              printGroupId: this.printerList[this.printerSelected].id,
              categoryId: this.newAddCategorySelected,
            })
            const isShowingArr = this.selectedShowThisMenu.map(it => it.id)
            const isFreeArr = this.selectedFreeMenu.map(it => it.id)
            for (const item of this.consumeTypeList) {
              (await DishesConsumeType.edit({
                consumeTypeId: (item.id).toString(),
                dishId: res.id,
                showing: isShowingArr.includes(item.id),
                isFree: isFreeArr.includes(item.id),
              }))
            }
            showSuccessMessage(this.$t('add_success'))
          })
        }
        await this.reload()
      },
      confirmToSubmit () {
        this.newAddPrinterName = this.printerList[this.printerSelected].name
        this.selectShowMenuName = this.selectedShowThisMenu.map(it => {
          return it.name
        }).join()
        this.selectFreeMenuName = this.selectedFreeMenu.map(it => {
          return it.name
        }).join()
        this.newAddCategorySelected = this.categoryList[this.categorySelected].id
        this.newAddCategorySelectedName = this.categoryList[this.categorySelected].langs[0].name
        this.step = 5
      },
      async reload () {
        this.printerSelected = null
        this.categorySelected = null
        await this.initialForm()
        this.step = 1
      },
      addNewAllergen (index) {
        this.showAllergenDialog = true
        this.activeAllergenIndex = index
      },
      async loadAllergen (item) {
        this.isRefreshAllergen = false
        await Allergen.getList(true)
        this.editedItem.AllergenId = item.content.id
        this.isRefreshAllergen = true
      },
      async loadCategory (item) {
        this.editedItem.categoryId = parseInt(item.content.id)
        this.categoryList = await Category.getList(true)
        this.categorySelected = this.categoryList.findIndex(it => it.id === parseInt(item.content.id))
        this.step = 3
      },
      async addNew (index) {
        this.showCategoryDialog = true
        this.activeCategoryIndex = index
      },

      resetDefaultItem () {
        this.defaultItem = this.calculateDefaultItem
      },

      fieldIsRequired (field) {
        return field.required && (
          (field.requiredEdit && this.editedIndex !== -1) ||
          (field.requiredNew && this.editedIndex === -1))
      },

      async initialForm () {
        this.currentList = this.outSideList ?? await IKUtils.safeCallFunction(this.model, this.model.getList, true)
        this.editedIndex = this.currentList.findIndex(i => parseInt(i.id) === parseInt(this.id))
        this.resetDefaultItem()
        this.editedItem = IKUtils.deepCopy(this.defaultItem)
        if (this.uniqueField.length > 0) {
          this.keyStore = {}
          this.keyStore = await this.uniqueField.reduce(async (obj, i) => {
            const trackingList = i.uniqueTrackingList ? await i.uniqueTrackingList() : this.currentList
            obj[i.value] = trackingList.map(it => it[i.value]).filter(it => it !== this.editedItem[i.value])
            return obj
          }, {})
          this.uniqueField.forEach(it => {
            it.rule = []
            if (this.keyStore[it.value]) {
              const uniqueCheck = val => (this.keyStore[it.value] && !this.keyStore[it.value].includes(val)) || this.$t(it.text) + this.$t('duplicated')
              it.rule.push(uniqueCheck)
            }
          })
        }
      },

      async wait (action) {
        this.loading = true
        try {
          await action()
        } catch (e) {

        }
        this.loading = false
      },

      async save () {
        this.editedIndex = -1
        if (this.editedIndex > -1) {
          await IKUtils.safeCallFunction(this.model, this.model.edit, this.editedItem)
          for (const d of this.consumeTypeList) {
            (await DishesConsumeType.edit({
              consumeTypeId: (d.id).toString(),
              dishId: this.$route.params.id,
              showing: false,
              isFree: false,
            }))
          }
          for (const x of this.selectedShowThisMenu) {
            (await DishesConsumeType.edit({
              consumeTypeId: (x.id).toString(),
              dishId: this.$route.params.id,
              showing: true,
            }))
          }
          for (const x of this.selectedFreeMenu) {
            (await DishesConsumeType.edit({
              consumeTypeId: (x.id).toString(),
              dishId: this.$route.params.id,
              isFree: true,
            }))
          }
          showSuccessMessage(this.$t('edit_success'))
          this.close(true)
        } else {
          for (const f of this.groupedFields) {
            copyToAll(f, this.editedItem[f.value])
          }
          if (!this.$refs.form.validate()) {
            return
          }
          await this.wait(async () => {
            const res = await Dish.add({
              ...this.editedItem,
              printGroupId: this.printerList[this.printerSelected].id,
              categoryId: this.newAddCategorySelected,
            })
            this.newDishCode = res.code
            this.$emit('close', this.newDishCode)
            const isShowingArr = this.selectedShowThisMenu.map(it => it.id)
            const isFreeArr = this.selectedFreeMenu.map(it => it.id)
            for (const item of this.consumeTypeList) {
              (await DishesConsumeType.edit({
                consumeTypeId: (item.id).toString(),
                dishId: res.id,
                showing: isShowingArr.includes(item.id),
                isFree: isFreeArr.includes(item.id),
              }))
            }
            showSuccessMessage(this.$t('add_success'))
          })
        }
      },
    },
  }
</script>

<style>
.theme--light.v-tabs > .v-tabs-bar {
  background: transparent !important;
}

.theme--light.v-tabs-items {
  background: transparent !important;
}
</style>
